/*
* Класс для проверки формы на странице.
* например, формы:
 * - announce
 * - user-review
 * - donate
 */

import {Form} from '../modules/Form';
import {event} from '../modules/event';


class PageForm {
	constructor(wrapper) {
        var self = this,
            param = JSON.parse(wrapper.getAttribute('data-param')) || {};
        
        this.oForm = new Form({
            wrapper:wrapper,
            beforeSubmit:function(){
                if(param.isNeedAuth){//check auth
                    if(APP.vars.isMobile){
                        if (APP.auth.tryAuth()) return true;
                        else return false;
                    } else {
                        if(!regAuthObj.isAuth){
                            regAuthObj.authForm.showPopup();
                            return false;
                        }
                        return true;
                    }
                }
                return true;
            },
            onsuccess:function(data){
                if(data.link) window.location.assign(data.link);
                else {
                    self.oForm.resetCaptcha();
                    if (APP.vars.isMobile) {
                        alert(data.message);
                    } else {
                        uPopup({
                            content:data.message
                        });
                    }
                    self.oForm.resetForm();
                }
            },
            onerror:function(data){
                self.oForm.resetCaptcha();
                if (APP.vars.isMobile) {
                    alert(data.message);
                } else {
                    uPopup({
                        content:data.message
                    });
                }
            }
        });
	}

    del(){
        this.oForm.del();
    }
}

export {PageForm};



